import React from 'react';
const FormStateContext = /*#__PURE__*/React.createContext({});
FormStateContext.displayName = 'FormState';
const FormApiContext = /*#__PURE__*/React.createContext({});
FormApiContext.displayName = 'FormApi';
const FormUpdaterContext = /*#__PURE__*/React.createContext({});
FormUpdaterContext.displayName = 'FormUpdater';
const ArrayFieldContext = /*#__PURE__*/React.createContext({
  shouldUseInitValue: true
});
export { FormStateContext, FormApiContext, FormUpdaterContext, ArrayFieldContext };